import { useLDClientCache } from './LDProviderWrapper';
import { ANONYMOUS_USER } from './constants';

export function useLDFlagValue(ldVariable: string) {
  const { clientCache, ldClinicianEmail } = useLDClientCache();
  // Try to get client using ldClinicianEmail, or fallback to ANONYMOUS_USER
  const emailKey = ldClinicianEmail || ANONYMOUS_USER;
  const ldClient = clientCache[emailKey];
  return ldClient?.variation(ldVariable, false);
}
